module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQBAMAAADt3eJSAAAAIVBMVEUAAAD////////////////////////////////////////PIev5AAAACnRSTlMAtkl/PwT06dG54SleagAAAEFJREFUCNdjAAIWBxDJpMTglsKgpMDAJchSOd1BcAEDF0OEs0krA4jBymwQAGYwMBsw4GAAAekMJTBYwMAoCAYCAJgwDyX0T2qCAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/comm/images/document-conversion/electronic/upload.png
// module id = cPGQ
// module chunks = 2